<script setup lang="ts">
import { ref } from 'vue'
import { copyToClipboard } from '@/utils/navigator-utils'

interface Props {
  text: string
  label?: string
}

const props = withDefaults(defineProps<Props>(), {
  label: 'Copy',
})

const isCopied = ref(false)

const handleCopy = async () => {
  const success = await copyToClipboard(props.text)
  if (success) {
    isCopied.value = true
    setTimeout(() => {
      isCopied.value = false
    }, 2000)
  }
}
</script>

<template>
  <button
    class="inline-flex items-center px-3 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 shadow-sm"
    @click="handleCopy"
  >
    <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
      />
    </svg>
    {{ isCopied ? 'Copied!' : label }}
  </button>
</template>
